import React, { useState } from "react";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import ConfirmationModal from "../../../shared-components/confirmation-modal/ConfirmationModal";

const MinorBookingModal = ({ open, onClose, onContinueAsMinor, isFirstMinor }) => {
  const { t } = useTranslation();
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbarClose = () =>
    setSnackbarConfig({ open: false, message: "", severity: "" });

  const handleContinueAsMinor = () => {
    if (onContinueAsMinor) {
      onContinueAsMinor();
    }
  };
 
  return (
    <>
      <ConfirmationModal
        open={open}
        onClose={onClose}
        title={t("minorBooking.title")}
        subtitle={t("minorBooking.subtitle")}
        disableBackdropClick={true}
        hideCloseIcon={true}
        actions={
          <>
            {!isFirstMinor && <Button
              variant="contained"
              sx={{
                width: { xs: "100%", sm: "180px", md: "214px" },
                height: "48px",
                borderRadius: "8px",
                padding: "12px 20px",
                background: "#1A407D",
                color: "#fff",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "24px",
                textTransform: "capitalize",
                "&:hover": { backgroundColor: "#092552" },
              }}
              onClick={handleContinueAsMinor}
            >
              {t("minorBooking.actions.continue")}
            </Button>}
            <Button
              variant="contained"
              sx={{
                width: { xs: "100%", sm: "180px", md: "214px" },
                height: "48px",
                borderRadius: "8px",
                padding: "12px 20px",
                background: "#1A407D",
                color: "#fff",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "24px",
                textTransform: "capitalize",
                "&:hover": { backgroundColor: "#092552" },
              }}
              onClick={onClose}
            >
              {t("minorBooking.actions.cancel")}
            </Button>
          </>
        }
      >
        <Typography sx={{ fontWeight: 600, mb: 1, fontSize: "14px" }}>
          {t("minorBooking.requirementsTitle")}
        </Typography>
        <ul className="requirementsList">
          <li>{t("minorBooking.requirements.point1")}</li>
          <li>{t("minorBooking.requirements.point2")}</li>
          <li>{t("minorBooking.requirements.point3")}</li>
          <li>{t("minorBooking.requirements.point4")}</li>
        </ul>
      </ConfirmationModal>

      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default MinorBookingModal;
